// iter591 — изнесен от Dashboard.jsx (Command Center портал с живи сигнали)
import React from "react";
import { Link } from "react-router-dom";

export default function ModulePortalLive({ icon, emoji, title, subtitle, signals, to, accent, isDark, testId }) {
  const tones = {
    emerald: { ring: isDark ? "hover:border-emerald-500/40" : "hover:border-emerald-200", text: isDark ? "text-emerald-300" : "text-emerald-700" },
    violet:  { ring: isDark ? "hover:border-violet-500/40"  : "hover:border-violet-200",  text: isDark ? "text-violet-300"  : "text-violet-700"  },
    sky:     { ring: isDark ? "hover:border-sky-500/40"     : "hover:border-sky-200",     text: isDark ? "text-sky-300"     : "text-sky-700"     },
    pink:    { ring: isDark ? "hover:border-pink-500/40"    : "hover:border-pink-200",    text: isDark ? "text-pink-300"    : "text-pink-700"    },
    amber:   { ring: isDark ? "hover:border-amber-500/40"   : "hover:border-amber-200",   text: isDark ? "text-amber-300"   : "text-amber-700"   },
    rose:    { ring: isDark ? "hover:border-rose-500/40"    : "hover:border-rose-200",    text: isDark ? "text-rose-300"    : "text-rose-700"    },
  }[accent] || { ring: "", text: isDark ? "text-gray-300" : "text-gray-700" };
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`group block rounded-2xl border p-4 transition-all hover:-translate-y-0.5 hover:shadow-md
        ${isDark ? "bg-[hsl(222,47%,9%)] border-white/5" : "bg-white border-gray-200"} ${tones.ring}`}
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="text-xl" aria-hidden="true">{emoji}</span>
        <h3 className={`text-sm font-bold ${isDark ? "text-white" : "text-[#1A1A2E]"}`}>{title}</h3>
      </div>
      {subtitle && (
        <div className={`text-[10px] uppercase tracking-wider font-semibold mb-2 ${tones.text}`}>{subtitle}</div>
      )}
      {!subtitle && <div className="mb-2" />}
      <ul className={`space-y-0.5 text-xs ${isDark ? "text-gray-300" : "text-gray-600"}`}>
        {(signals || []).map((s, i) => (
          <li key={i}>{s}</li>
        ))}
      </ul>
      <div className="mt-3 flex items-center justify-end">
        <span className={`inline-flex items-center gap-1 text-xs font-semibold ${tones.text} group-hover:translate-x-0.5 transition-transform`}>
          ➜ {/* arrow */}
        </span>
      </div>
    </Link>
  );
}
